import { PastDueHomeownerAppointmentSchema } from "../schemas/jwt";
import { PastDueHomeownerAppointment } from "./index";

export function isPastDueHomeownerAppointment(data: unknown): data is PastDueHomeownerAppointment {
  return PastDueHomeownerAppointmentSchema.safeParse(data).success;
}
